import React from 'react';

// 2FA v2 app-approval surface. NO input, NO toggle, NO confirmation
// button — the V3 driver polls LinkedIn for the post-approval redirect
// and publishes login_success / email_change_success when it fires.
// The seller's only job is to tap Approve on their phone.
//
// `subtitle` lets Step 5 vs Step 10 customise the trailing line
// ("login request" vs "email change") without duplicating the layout.
export default function ApproveOnPhone({ subtitle, error }) {
  const errorStyle = {
    color: 'var(--danger, #ef4444)',
    fontSize: 13,
    marginTop: 12,
    textAlign: 'center',
  };

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: 16,
      padding: '24px 0',
    }}>
      <style>{`@keyframes pulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.4; } }`}</style>
      <div style={{
        width: 56,
        height: 56,
        borderRadius: '50%',
        background: 'rgba(37, 99, 235, 0.15)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        animation: 'pulse 2s ease-in-out infinite',
      }}>
        <div style={{
          width: 28,
          height: 28,
          borderRadius: '50%',
          background: 'var(--primary)',
        }} />
      </div>

      <p style={{
        color: 'var(--text)',
        fontSize: 16,
        fontWeight: 600,
        textAlign: 'center',
        margin: 0,
      }}>
        Open the LinkedIn app on your phone and tap <strong>Approve</strong>.
      </p>

      <p style={{
        color: 'var(--text2)',
        fontSize: 14,
        lineHeight: 1.5,
        textAlign: 'center',
        margin: 0,
        maxWidth: 320,
      }}>
        {subtitle || "We'll continue automatically once LinkedIn confirms the approval."}
      </p>

      {error && <p style={errorStyle}>{error}</p>}
    </div>
  );
}
